/**
 * O LINK PÚBLICO DA PROPOSTA, num lugar só (pedido do Heitor, 28/10/2026). O botão Link do cartão e o contrato digital
 * (variável `oportunidade.propostaAprovada.urlLinkPublico`, nas duas telas que montam o contrato) montavam o link cada um
 * do seu jeito, e o do contrato saía sem o `v=`. Agora os dois chamam esta função e não têm como divergir.
 *
 * /p/:code = link com card rico no WhatsApp (rewrite Vercel condicional por UA: crawler → backend OG, humano → SPA).
 * `template` abre com o layout da proposta que o cliente viu. O `v={updatedAt}` fura o cache do WhatsApp: ao editar a
 * proposta, o updatedAt muda, a URL muda e o card é re-capturado.
 */
export function linkPublicoDaProposta(
  proposta: { code?: string | null; updatedAt?: string | Date | null } | null | undefined,
  templateId: number | null | undefined,
  origem: string = typeof window !== 'undefined' ? window.location.origin : 'https://hub.ipcom.app.br',
): string {
  if (!proposta?.code) return '';
  const params = new URLSearchParams();
  if (templateId) params.set('template', String(templateId));
  if (proposta.updatedAt) params.set('v', String(new Date(proposta.updatedAt).getTime()));
  const qs = params.toString();
  return `${origem}/p/${proposta.code}${qs ? `?${qs}` : ''}`;
}

/** O layout que o link usa quando ninguém escolheu outro: o modelo de proposta padrão ativo, ou o primeiro ativo. */
export function templatePadraoDaProposta(templates: Array<{ id: number; isDefault?: boolean; isActive?: boolean }> | null | undefined): number | null {
  const ativos = (templates || []).filter((t) => t.isActive !== false);
  return (ativos.find((t) => t.isDefault) || ativos[0])?.id ?? null;
}
